import React from 'react';
import './governance.css';

function Governance() {
  const boardMembers = [
    {
      name: 'Dr. Sandra Block',
      title: 'WCO PRESIDENT',
      image: '/user.jpg',
    },
    {
      name: 'Dr. Cindy Tromans',
      title: 'PRESIDENT-ELECT',
      image: '/user.jpg',
    },
    {
      name: 'Prof. Peter Hendicott',
      title: 'IMMEDIATE PAST PRESIDENT',
      image: '/user.jpg',
    },
  ];

  const committeeChairs = [
    {
      name: 'Dr. Roger Jordan',
      title: 'LRS COMMITTEE CHAIR',
      image: '/user.jpg',
    },
    {
      name: 'Dr. Priya Morjaria',
      title: 'PUBLIC HEALTH COMMITTEE CHAIR',
      image: '/user.jpg',
    },
    {
      name: 'Dr. Yazan Gammoh',
      title: 'EDUCATION COMMITTEE CHAIR',
      image: '/user.jpg',
    },
  ];


  const geographic_representative = [
    {
      name: 'Dr. Roger Jordan',
      title: 'LRS COMMITTEE CHAIR',
      image: '/user.jpg',
    },
    {
      name: 'Dr. Priya Morjaria',
      title: 'PUBLIC HEALTH COMMITTEE CHAIR',
      image: '/user.jpg',
    },
    {
      name: 'Dr. Yazan Gammoh',
      title: 'EDUCATION COMMITTEE CHAIR',
      image: '/user.jpg',
    },
  ];
  

  return (
    <div className="board-page">
      <h1>Board of Directors</h1>

      <div className="board-section">
        <h2>PRESIDENTS GROUP</h2>
        <div className="board-grid">
          {boardMembers.map((member, index) => (
            <div key={index} className="board-card">
              <img src={member.image} alt={member.name} className="board-member-image" />
              <h3>{member.title}</h3>
              <p>{member.name}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="board-section">
        <h2>COMMITTEE CHAIRS</h2>
        <div className="board-grid">
          {committeeChairs.map((chair, index) => (
            <div key={index} className="board-card">
              <img src={chair.image} alt={chair.name} className="board-member-image" />
              <h3>{chair.title}</h3>
              <p>{chair.name}</p>
            </div>
          ))}
        </div>
      </div>


      <div className="board-section">
        <h2>GEOGRAPHIC REPRESENTATIVES</h2>
        <div className="board-grid">
          {geographic_representative.map((chair, index) => (
            <div key={index} className="board-card">
              <img src={chair.image} alt={chair.name} className="board-member-image" />
              <h3>{chair.title}</h3>
              <p>{chair.name}</p>
            </div>
          ))}
        </div>
      </div>



    </div>
  );
}

export default Governance;
